import {
  isSubTemplatedField,
  isSubTemplatedFieldValue,
  isTemplateField,
  isTemplateVersion,
} from '../../types/templateModel'
import { SubTemplatedFieldValueCell } from './SubTemplatedFieldValueCell'
import { TemplateFieldCell } from './TemplateFieldCell'
import type { TemplateFieldTableParent } from './TemplateFieldsTable'
import { TemplateVersionCell } from './TemplateVersionCell'

type Props = {
  data: TemplateFieldTableParent
  column: number
  row?: number
}

export const ParentFieldTableCell = ({ data, column }: Props) => {
  if (isTemplateField(data) && isSubTemplatedField(data)) {
    return <TemplateFieldCell field={data} isHeaderRow column={column} />
  } else if (isSubTemplatedFieldValue(data)) {
    return <SubTemplatedFieldValueCell variant={data} column={column} />
  } else if (isTemplateVersion(data)) {
    return <TemplateVersionCell column={column} />
  } else {
    throw new Error(`Unsupported field type ${data}`)
  }
}
